<template>
    <div>
        <a v-if="!hasCustomTemplate" @click="openArticle($event)" :href="href" :target="target" class="ecm-item-card">

            <div v-if="image" class="ecm-item-card-img" :style="imgDivStyle"></div>

            <h2 class="ecm-item-card-title">{{ title }}</h2>

            <h3 v-if="popupItem.subtitle" class="ecm-item-card-subtitle">{{ popupItem.subtitle }}</h3>

            <div v-if="routeLength || badges" class="ecm-item-card-info">
                <span 
                    v-for="badge in badges" 
                    :key="badge.id" 
                    :class="getBadgeClass(badge.id)">
                    {{ badge.name }}
                </span>
                <p v-if="routeLength" class="ecm-item-card-route-length">{{ (routeLength / 1000).toFixed(2) }} km</p>
            </div>

            <p v-if="description" v-html="descriptionNl2Br" class="ecm-item-card-description"></p>

            <div v-if="popupItem.category && Array.isArray(popupItem.category)">
                <div 
                    v-for="cat in popupItem.category" 
                    :key="cat"
                    class="ecm-item-card-category">
                    {{ cat }}
                </div>
            </div>
            <div v-else-if="popupItem.category" class="ecm-item-card-category">{{ popupItem.category }}</div>

            <p v-if="!isDirectLink" class="ecm-item-card-read-more">
                {{ $t("readMore") }}
            </p>

            <p v-if="isDirectLink" class="ecm-item-card-read-more ecm-item-card-open-link" :style="{ color: themeColor }">
                {{ $t("openLink") }}
                <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" class="ecm-item-card-external-icon" width="20" height="20" fill="currentColor">
                    <path d="M19 19H5V5h7V3H5c-1.11 0-2 .9-2 2v14c0 1.1.89 2 2 2h14c1.1 0 2-.9 2-1v-7h-2v7zM14 3v2h3.59l-9.83 9.83 1.41 1.41L19 6.41V10h2V3h-7z"/>
                </svg>
            </p>

            <ItemCategories v-if="!isDirectLink" :categories="categories" />

            <div v-if="tags" class="ecm-item-card-tags">
                <img
                    v-for="tag in tags"
                    :key="'tag-' + tag.id"
                    :src="tag.icon"
                    :alt="tag.name"
                />
            </div>

        </a>

        <component v-if="hasCustomTemplate" :is="customTemplateName" :popupItem="popupItem" />

    </div>

</template>

<script>
//import { popup } from 'leaflet';
import { eventBus } from '../main.js';
import { store } from '../store/store';
import ItemCategories from './ItemCategories.vue';
import ItemCardRealEstate from './templates/ItemCardRealEstate.vue';

export default {
    name: 'ItemCard',
    components: {
        ItemCategories,
        ItemCardRealEstate
    },
    props: {
        articleApiUrl: null,
        id: null,
        image: null,
        title: null,
        routeLength: null,
        description: null,
        url: null,
        hasText: null,
        hasGpx: null,
        target: null,
        categories: null,
        tags: null,
        badges: null,
        sourceId: null,
        popupItem: null
    },
    data() {
        return {

        }
    },
    computed: {
        isDirectLink() {
            return this.popupItem && this.popupItem.isDirectLink == true;
        },
        href() {
            if (this.isDirectLink || this.popupItem.external) {
                return this.ensureProtocol(this.url);
            }
            return '#';
        },
        config() {
            return store.state.config;
        },
        hasCustomTemplate() {
            return this.config && this.config.templates && this.config.templates.itemCard;
        },
        customTemplateName() {
            if (this.config && this.config.templates && this.config.templates.itemCard) {
                return this.config.templates.itemCard;
            }
            return null; 
        },
        imgDivStyle() {
            return 'background-image:url(' + this.image + ');';
        },
        descriptionNl2Br() {
            if (this.description && this.description != '') {
                return this.description.replace(/(?:\r\n|\r|\n)/g, '<br />');
            }
            return this.description;
        },
        themeColor() {
            if (store.state.config && store.state.config.themeColor) {
                return store.state.config.themeColor;
            }
            return '#000000';
        }
    },
    methods: {
        ensureProtocol(url) {
            if (!url) return url;
            // Check if URL already has a protocol
            if (/^https?:\/\//i.test(url)) {
                return url;
            }
            // Add https:// if missing
            return 'https://' + url;
        },
        getBadgeClass(badgeId) {
            return 'ecm-item-card-badge ecm-item-card-badge-' + badgeId;
        },
        openArticle(e) {
            if (this.isDirectLink) {
                // Direct link - let the browser handle it (open in new tab)
                return;
            }
            if (this.popupItem.external) { 
                // It's external
                this.openExternalLink();
            } else {
                e.preventDefault();
                eventBus.$emit('loadArticle', {
                    articleApiUrl: this.articleApiUrl,
                    id: this.id,
                    sourceId: this.sourceId
                });
            }
        },
        openExternalLink() {
            let viewData = {
                viewType: 'ARTICLE_OPEN',
                externalId: this.id,
                externalTitle: this.title,
                externalUrl: this.url
            };
            eventBus.$emit('articleOpen', viewData);
        }
    }
}

</script>

<style scoped>
.ecm-item-card {
    display: block;
    color: #000;
}
.ecm-item-card-img {
    height: 0;
    background-color: #ddd;
    background-size: cover;
    background-position: center;
    background-repeat: no-repeat;
    padding-top: 66.6666666666667%;
}
.ecm-item-card-title {
    font-size: 1.125rem;
    line-height: 1.25rem;
    color: #000;
    margin: 1rem 0 .5rem 0;
    display: flex;
    align-items: center;
    gap: 0.5rem;
}
.ecm-item-card-title-icon {
    flex-shrink: 0;
}
.ecm-item-card-title-icon svg {
    fill: currentColor;
}
.ecm-item-card-subtitle {
    font-size: 1rem;
    line-height: 1rem;
    color: #000;
    margin: 0 1rem .5rem 1rem;
}
.ecm-item-card-description {
    margin: 0 0 1rem 0;
}
.ecm-item-card-read-more {
    color: #999;
    text-align: center;
    margin: 0;
}
.ecm-item-card-open-link {
    display: flex;
    align-items: center;
    justify-content: center;
    gap: 0.5rem;
    font-weight: 500;
    padding-bottom: 1rem;
}
.ecm-item-card-open-link svg {
    fill: currentColor;
}
.ecm-item-card-external-icon {
    flex-shrink: 0;
}
.ecm-item-card-external-icon svg {
    fill: currentColor;
}
</style>
